export const TABLE_ERASE_MODAL_PARTIAL = 'TABLE_ERASE_MODAL_PARTIAL';
